import { getGraphqlClient } from "@lib/graphql-client"
import { useQuery } from "@tanstack/react-query"

const { sdk } = getGraphqlClient()

export function useAccount() {
  const { data } = useQuery({
    queryKey: ["account"],
    queryFn: () => sdk.Account(),
  })
  return data?.account
}
